<template>
  <div class="footer-page">
    <div class="container">
      <div class="item">
        <img class="logo-img" :src="footer_logo" />
      </div>
      <!-- {{ footer_text }} -->
      <template v-for="item in footer_text">
        <ul>
          <li class="title">{{ item.name }}</li>
          <template v-for="val in item.list">
            <li :class="{ row: item.key != 'service' }" @click="go(item)">{{ val.name }}</li>
          </template>
        </ul>
      </template>
    </div>
    <div class="copyright">{{ beian }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'footerPage',
  computed: {
    ...mapState(['config']),
    footer_logo() {
      return this.config.footer_logo || require('@/assets/images/kai-logo.png')
    },
    footer_text() {
      let foot = this.config.footer_text || {}
      let keys = Object.keys(foot)
      return Object.values(foot).map((item, index) => {
        item.key = keys[index]
        return item
      })
    },
    beian() {
      return this.config.beian || ''
    }
  },

  methods: {
    go(item) {
      if (item.richtext_id) {
        this.$goTo('/aboutMe?id=' + item.richtext_id)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.footer-page {
  background-color: #4d5056;

  .container {
    display: flex;
    justify-content: space-between;
    padding-top: 34px;
    padding-bottom: 8px;
    padding-right: 46px;

    .logo-img {
      width: 180px;
      height: auto;
    }

    ul {
      li {
        list-style-type: none;
        color: #fff;
        opacity: .8;
        font-size: 12px;
        margin-bottom: 16px;

        &.title {
          margin-bottom: 20px;
          font-size: 18px;
        }

        &.row {
          cursor: pointer;

          &:not(:first-child) {
            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }

  .copyright {
    line-height: 44px;
    padding-top: 5px;
    color: #666;
    text-align: center;
    font-size: 12px;
    background: #fff;
  }
}
</style>
